var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"trafimage-map-container",attrs:{"src":"/portal/static_pages/trafimage_maps/index-redirect.html","title":_vm.title,"frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }